import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TimelineItemContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TimelineItemContext.displayName = 'TimelineItemContext';
}

export default TimelineItemContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineItem/TimelineItemContext.js
// module id = 572
// module chunks = 2